// import React from "react";
// import { Autocomplete, TextField } from "@mui/material";

// export const SimpleAutoSelect = ({
//   options = [],
//   value = null,
//   onChange,
//   getOptionLabel,
//   label = "Select",
//   width = "100%",

// }) => {
//   return (
//     <Autocomplete
//       options={options}
//       value={value || null} // siguro që nuk është undefined
//       onChange={(event, newValue) => {
//         onChange(newValue); // ruan objektin e plotë
//       }}
//       getOptionLabel={(opt) => getOptionLabel(opt) || ""} // shfaq emrin
//       renderInput={(params) => (
//         <TextField
//           {...params}
//           label={label}
//           placeholder={label}
//           variant="outlined"
          
//         />
//       )}
//       style={{ width}}
//     />
//   );
// };

import React from "react";
import { Autocomplete, TextField } from "@mui/material";

export const SimpleAutoSelect = ({
  options = [],
  value = null,
  onChange,
  getOptionLabel,
  label = "Select",
  width = "100%",
  maxVisibleOptions = 3, // shto param për max rreshta
}) => {
  // llogarit lartësinë e dropdown për 3 rreshta
  const optionHeight = 48; // lartësia default e çdo rreshti në MUI Autocomplete
  const maxHeight = optionHeight * maxVisibleOptions;

  return (
    <Autocomplete
      options={options}
      value={value || null}
      onChange={(event, newValue) => {
        onChange(newValue);
      }}
      getOptionLabel={(opt) => getOptionLabel(opt) || ""}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={label}
          variant="outlined"
        />
      )}
      ListboxProps={{
        style: {
          maxHeight: `${maxHeight}px`,
          overflowY: "auto", // scroll kur ka më shumë se maxVisibleOptions
        },
      }}
      style={{ width }}
    />
  );
};